import { sanitize } from 'dompurify'
import css from './search.css'

global.Giphy = global.Giphy || {}
global.Giphy.search = term => {
    if (!term) return
    const sanitizedTerm = sanitize(term)
    global.trackEvent('Search', sanitizedTerm)
    window.location.href = `https://giphy.com/search/${encodeURIComponent(sanitizedTerm)}`
}

export default function() {
    return `<form class="${css.container}" onsubmit="Giphy.search(document.querySelector('.${css.searchInput}').value);return false;">
        <input class="${css.searchInput}" placeholder="Search GIPHY" name="search" type="text" required />
        <button class="${css.searchButton}" type="submit"></button>
    </form>`
}
